var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}${_vm.slug}`,"viewBox":"0 0 16 16"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"5.5","fill":"none","stroke-width":"5","stroke":_vm.getColor('sign')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }